import styled, { css } from 'styled-components';
import { Box, TextField, TextStyled, BoxProps } from '@bechtel/gds';

interface TimeEntryCellProps {
  hasError: boolean;
}

export const TimeEntryCellStyled = styled(Box).attrs({
  mx: { sm: '200' },
})<TimeEntryCellProps>`
  ${({ theme, hasError }) => css`
    border: 1px solid ${!hasError ? theme.colors.grey[300] : theme.colors.red[500]};
    border-radius: ${theme.radii[200]};
    width: 100%;
  `};
`;
export const HourTextFieldStyled = styled(TextField)`
  border: 0;
  ${({ theme }) => css`
    padding-left: ${theme.spacings[400]};
  `};
`;

export interface CommentsBoxStyledProps {
  disabled: boolean;
}

export const CommentsBoxStyled = styled(Box).attrs({
  pr: { sm: '500' },
  alignItem: { sm: 'center' },
  ml: { sm: '300' },
})<CommentsBoxStyledProps>`
  ${({ theme, disabled }) => css`
    position: relative;
    cursor: pointer;
    ${disabled && 'pointer-events:none;'}
    ${TextStyled} {
      position: absolute;
      top: ${theme.spacings[400]};
      left: ${theme.spacings[400]};
      padding: ${theme.spacings[100]};
      background-color: ${theme.colors.white};
      border-radius: ${theme.spacings[300]};
    }
  `}
`;
